import React from "react";

const prepareStyles = (customStyles: any) => {

  const chatMessagesContainer = customStyles?.chatMessagesContainer;
  const chatUserMessageContainer = customStyles?.chatUserMessageContainer;
  const chatBotMessageContainer = customStyles?.chatBotMessageContainer;

  return `
    .chat-bubble::before,
    .chat-bubble::after {
      content: '';
      bottom: -7px;
      height: ${chatBotMessageContainer?.borderRadius || "20px"};
      position: absolute;
      z-index: 1;
    }
    
    .chat-bubble.bot::before {
      border-color: ${chatBotMessageContainer?.backgroundColor || "#FFFFFF"};
      border-left-style: solid;
      border-left-width: ${chatBotMessageContainer?.borderRadius || "20px"};
      border-bottom-right-radius: 100%;
      
      left: ${"-"+parseFloat(chatBotMessageContainer?.borderRadius)/2 +"px" || "-10px"};
      transform: rotate(15deg);
    }

    .chat-bubble.bot::after {
      background: ${chatMessagesContainer?.backgroundColor || "red"};
      border-bottom-right-radius: 50%;
      border-top-right-radius: 75%;
      width: ${parseFloat(chatBotMessageContainer?.borderRadius)/1.5 +"px" || "10px"};
      z-index: 1;
      transform: rotate(35deg);
      height: 50px;
      bottom: -5px;
      left: -29.5px;
    }

    .chat-buble.user {
      background: ${chatUserMessageContainer?.backgroundColor || '#EBEBEB'};
      margin-left: auto;
    }  
    .chat-bubble.user::before, 
    .chat-bubble.user::after {
      left: auto;
      right: -10px;
    }
    
    .chat-bubble.user::before {
      border-color: ${chatUserMessageContainer?.backgroundColor || "#EBEBEB"};
      border-right-style: solid;
      border-right-width: ${chatUserMessageContainer?.borderRadius || "10px"};
      border-bottom-left-radius: 100%;
      right: ${"-"+parseFloat(chatBotMessageContainer?.borderRadius)/2 +"px" || "-10px"};
      transform: rotate(-15deg);
    }
    .chat-bubble.user::after {
      background: ${chatMessagesContainer?.backgroundColor || "red"};
      border-bottom-left-radius: 50%;
      border-top-left-radius: 75%;
      width: ${parseFloat(chatUserMessageContainer?.borderRadius)/1.5 +"px" || "10px"};
      transform: rotate(-35deg);
      height: 50px;
      bottom: -5px;
      right: -29.5px;
    }
  `
}



export function UserBubleType3({customStyles, children}: any) {
  return (
    <>
      <style>{prepareStyles(customStyles)}</style>
      <div className="chat-bubble inner user">
        {children}
      </div>
    </>
  )
}


export function BotBubleType3({customStyles, children}: any) {
  return (
    <>
      <style>{prepareStyles(customStyles)}</style>
      <div className="chat-bubble inner bot">
        {children}
      </div>
    </>
  )
}
